import Head from "next/head"
import { useState, useEffect } from "react"

import useStorage from "@/hooks/useStorage"

import DatasetsPage from "@/components/pages/DatasetsPage"

import TopNav from "@/components/TopNav"

const Datasets = () => {
  const { initialized, storage } = useStorage()
  const [datasetDescList, setDatasetDescList] = useState(false)

  useEffect(() => {
    if (!initialized || !storage) {
      return
    }

    storage
      .getDatasetList()
      .then((datasets) => {
        storage.getChartsCount().then((aggData) => {
          for (const dataset of datasets) {
            const cnt = aggData[dataset.id] ? aggData[dataset.id].length : 0
            dataset["chartsCount"] = cnt
          }
          setDatasetDescList(datasets)
        })
      })
      .catch((error) => console.warn(error))
  }, [initialized, storage])

  const deleteDataset = (datasetId) => {
    storage
      .deleteDataset(datasetId)
      .then((isDeleted) => {
        if (!isDeleted) {
          alert("Nothing deleted")
        } else {
          // refresh
          // TODO: clean this up, redundant code
          storage
            .getDatasetList()
            .then((datasets) => {
              storage.getChartsCount().then((aggData) => {
                for (const dataset of datasets) {
                  const cnt = aggData[dataset.id]
                    ? aggData[dataset.id].length
                    : 0
                  dataset["chartsCount"] = cnt
                }
                setDatasetDescList(datasets)
              })
            })
            .catch((error) => console.warn(error))
        }
      })
      .catch((error) => {
        alert(error.message)
        console.error(error)
      })
  }

  if (!datasetDescList) {
    return <div>Loading</div>
  }

  // Make nav bar
  const NavBar = <TopNav />

  console.debug("Datasets : ", datasetDescList)

  return (
    <>
      <Head>
        <title>Datasets - Vizdium</title>
      </Head>
      <DatasetsPage
        datasetDescList={datasetDescList}
        NavBar={NavBar}
        deleteDataset={deleteDataset}
      />
    </>
  )
}

export default Datasets
